import { topList } from "@/mocks/manga";

const medals = ["bg-secondary-500", "bg-background-300 text-foreground-700", "bg-primary-300 text-background-50"];

export default function RankSection() {
  return (
    <section id="rank" className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-trophy-line"></i> TOP RANK
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">火影同人漫画热门榜单</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            综合人气、追更人数与读者评分整理的当周人气排名，助你快速找到口碑与热度双高的同人作品。
          </p>
        </div>
        <span className="whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900">每日 10:00 更新</span>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {topList.map((item, idx) => (
          <article
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition-transform hover:-translate-y-1"
          >
            <div className="relative">
              <img
                src={item.cover}
                alt={`${item.title} - 火影同人漫画封面`}
                className="h-56 w-full object-cover object-top sm:h-52"
              />
              <span
                className={`absolute left-3 top-3 flex h-7 min-w-7 items-center justify-center rounded-md px-2 font-heading text-sm font-bold text-background-50 ${medals[idx] ?? "bg-accent-500"}`}
              >
                {idx + 1}
              </span>
              <span className="absolute bottom-3 right-3 whitespace-nowrap rounded-md bg-black/55 px-2 py-1 text-xs text-background-50">
                {item.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex items-center justify-between gap-2">
                <h3 className="truncate font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <span className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-accent-600">
                  <i className="ri-star-fill"></i> {item.score.toFixed(1)}
                </span>
              </div>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i> {item.views} 人气
                </span>
                <a href="#update" className="whitespace-nowrap font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                  立即阅读 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}